<template>
  <div>
    <h1>Terms of Service</h1>
  </div>
</template>

